import { Warning, WarningsToDisplayProvider } from '@app/interfaces/warnings-to-display-provider.interface';
import { Employee } from '@app/models/employee/employee.model';
import { values } from 'lodash-es';

export class PersonalShowWarningProvider implements WarningsToDisplayProvider {
    private employee: Employee;
    private payrollEnabled: boolean;
    private warnings = {
        missingSin: {
            message: 'employees.personal.missingSin',
            active: false,
        },
    };

    constructor(employee: Employee, payrollEnabled: boolean) {
        this.employee = employee;
        this.payrollEnabled = payrollEnabled;
        this.determineActiveWarnings();
    }

    warningsToDisplay(): Warning[] {
        return values(this.warnings).filter((warning) => warning.active);
    }

    private determineActiveWarnings(): void {
        if (this.payrollEnabled == false) {
            return;
        }

        this.markSocialInsuranceNumberMissing();
    }

    private markSocialInsuranceNumberMissing(): void {
        if (this.employee.hasAttribute('sin') == false) {
            return;
        }

        if (this.employee.sin?.length) {
            return;
        }

        this.warnings.missingSin.active = true;
    }
}
